// TODO: implement debounce

import { FlightFactory } from 'classes';
import store from 'store';

import { clearActiveAircraft, setActiveAircraft } from 'actions';

import { FLIGHT_GET_API_REQUEST_PAGE_SIZE } from 'constants';

export const CLEAR_ACTIVE_FLIGHT = 'CLEAR_ACTIVE_FLIGHT';
export const FETCH_ACTIVE_FLIGHT = 'FETCH_ACTIVE_FLIGHT';
export const FETCH_FLIGHT_LIST = 'FETCH_FLIGHT_LIST';
export const SET_ACTIVE_FLIGHT = 'SET_ACTIVE_FLIGHT';
export const UPDATE_ACTIVE_FLIGHT = 'UPDATE_ACTIVE_FLIGHT';
export const UPDATE_FLIGHT_MAP = 'UPDATE_FLIGHT_MAP';
export const UPDATE_FLIGHT_LIST = 'UPDATE_FLIGHT_LIST';

var activeFlightRequest = null;

export function clearActiveFlight() {
  return {
    type: CLEAR_ACTIVE_FLIGHT,
  };
}

export function setActiveFlight(flight) {
  return async (dispatch) => {
    const { activeAircraft, aircraftMap } = store.getState();

    // Set active aircraft
    // if current activeAircraft is not for the flight.
    if (!activeAircraft || flight.aircraft_id !== activeAircraft.id) {
      dispatch(clearActiveAircraft());
      const aircraft = aircraftMap.get(flight.aircraft_id);
      dispatch(setActiveAircraft(aircraft));
    }

    dispatch({
      type: SET_ACTIVE_FLIGHT,
      activeFlight: flight,
    });

    if (activeFlightRequest) {
      activeFlightRequest.cancel();
    }

    if (!flight) {
      return;
    }

    dispatch({
      type: FETCH_ACTIVE_FLIGHT,
    });

    const fid = flight.id;
    activeFlightRequest = FlightFactory.getFlightById(fid);
    activeFlightRequest.then((activeFlight) => {
      if (activeFlight) {
        dispatch({
          type: SET_ACTIVE_FLIGHT,
          activeFlight,
        });
      }

      activeFlightRequest = null;
    });
  };
}

export function updateActiveFlight() {
  return async (dispatch) => {
    const { activeFlight: currentFlight } = store.getState();
    // ignore request if no current active flight or if the current flight is closed
    if (!currentFlight || currentFlight.is_open === false) {
      return;
    }

    if (activeFlightRequest) {
      activeFlightRequest.cancel();
    }

    dispatch({
      type: FETCH_ACTIVE_FLIGHT,
    });

    const ftFetchDt = currentFlight.modified + 1000;
    const fid = currentFlight.id;
    activeFlightRequest = FlightFactory.getFlightById(fid, ftFetchDt);
    activeFlightRequest.then((activeFlight) => {
      if (activeFlight) {
        dispatch({
          type: UPDATE_ACTIVE_FLIGHT,
          activeFlight,
        });
      }

      activeFlightRequest = null;
    });
  };
}

export function updateFlightMap(
  dt,
  pageSize = FLIGHT_GET_API_REQUEST_PAGE_SIZE,
) {
  return async (dispatch) => {
    dispatch({
      type: FETCH_FLIGHT_LIST,
    });

    const { flightMap: currentFlightMap } = store.getState();
    let ftListFetchDt = dt;

    if (!ftListFetchDt) {
      currentFlightMap?.forEach((flight) => {
        if (!ftListFetchDt || flight.modified > ftListFetchDt) {
          ftListFetchDt = flight.modified + 1000;
        }
      });
    }

    // Initializing flightcount variable with pageSize to avoid unnecessary calls if the flight list is not
    // fetching any new flights and count is 0.
    let flightCount = pageSize;
    let page = 0;
    let flightMap = new Map();

    while (flightCount === pageSize) {
      const { flightMap: flights, ct } = await FlightFactory.getAllFlights(
        ftListFetchDt,
        ++page,
        pageSize,
      );
      flightCount = ct;
      flightMap = new Map([...flightMap, ...flights]);
    }

    await dispatch({
      type: UPDATE_FLIGHT_MAP,
      flightMap,
    });

    const { flightMap: updatedFlightList } = store.getState();

    dispatch({
      type: UPDATE_FLIGHT_LIST,
      flightList: Array.from(updatedFlightList.values()),
    });
  };
}

export function getInitialFlightList(ids, dt) {
  return async (dispatch) => {
    dispatch({
      type: FETCH_FLIGHT_LIST,
    });
    const result =
      ids.length > 0
        ? await FlightFactory.getFlightsByIds(ids)
        : await FlightFactory.getAllFlights(dt);

    await dispatch({
      type: UPDATE_FLIGHT_MAP,
      flightMap: result instanceof Map ? result : result.flightMap || new Map(),
    });

    const { flightMap: updatedFlightList } = store.getState();

    dispatch({
      type: UPDATE_FLIGHT_LIST,
      flightList: Array.from(updatedFlightList.values()),
    });
  };
}
